import angular from 'angular';
import {
    ListStockItems,
    Reports,
    ExternalReport,
    ProductMovements,
    ProductMovementsFromMenu,
    MatchesInfo,
    SalesPurchases,
} from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-stock';

angular
    .module(moduleName, [])
    .directive('listStockItems', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ListStockItems);

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('cashReports', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (scope, el) => {
                Backoffice.renderComponent(el[0], Reports, {
                    showPermissionDeniedState:
                        scope.app?.club
                            ?.hasCashReportEmployeeRestrictionEnabled?.() ===
                        true,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('salesPurchases', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (scope, el) => {
                Backoffice.renderComponent(el[0], SalesPurchases, {
                    showPermissionDeniedState:
                        scope.app?.club
                            ?.hasSalesPurchasesReportEmployeeRestrictionEnabled?.() ===
                        true,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsBookings', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'RESERVAS',
                    queryKey: 'bookings',
                    dashboardId: 10,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsCancellations', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'CANCELACIONES',
                    queryKey: 'cancellations',
                    dashboardId: 15,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsPlayers', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'JUGADORES',
                    queryKey: 'players',
                    dashboardId: 14,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsTeachersAndTournaments', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'PROFESORES, ESCUELITAS Y TORNEOS',
                    queryKey: 'teachers_and_tournaments',
                    dashboardId: 13,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsStock', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'STOCK',
                    queryKey: 'stock',
                    dashboardId: 11,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsReceipts', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'COBROS',
                    queryKey: 'receipts',
                    dashboardId: 16,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsControl', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'CONTROL',
                    queryKey: 'control',
                    dashboardId: 12,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('metricsBuffet', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], ExternalReport, {
                    title: 'MESAS Y CUENTAS',
                    queryKey: 'buffet',
                    dashboardId: 20,
                });

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('matchesInfo', [
        'Backoffice',
        (Backoffice) => ({
            restrict: 'A',
            link: (_scope, el) => {
                Backoffice.renderComponent(el[0], MatchesInfo);

                // Al destruirse, desmontar el root de React (evita fugas en body).
                _scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ])
    .directive('registerMovement', [
        'Backoffice',
        'moment',
        (Backoffice, moment) => ({
            restrict: 'A',
            link: (scope, el) => {
                const props = scope.vm.movement;

                const isFromMenu = !props.booking_id;

                if (isFromMenu) {
                    // Desde el menú: usar el nuevo componente con tabs
                    // 'deposit' -> flujo de productos (Compra/Venta)
                    // 'extraction' -> flujo de dinero (Retiro/Ingreso)
                    // Para 'extraction', usar 'expense' por defecto (Retiro)
                    // El usuario podrá cambiar a 'income' (Ingreso) desde las tabs
                    const type =
                        props.type === 'extraction' ? 'expense' : 'deposit';

                    Backoffice.renderComponent(
                        el[0],
                        ProductMovementsFromMenu,
                        {
                            ...props,
                            type,
                            created_by: {
                                user: props.user,
                                player: props.player,
                            },
                            concept_details: {
                                booking_date: '-',
                                court: props.court || '',
                                booking_id: props.booking_id,
                            },
                            onCloseModal: scope.vm.$close,
                            bookingMovementInfo: {
                                ...props,
                                type,
                            },
                            getUserCode: scope.vm.getUserCode,
                            registerBookingInfoMovement:
                                scope.vm.registerBookingInfoMovement,
                        },
                    );
                } else {
                    // Desde las grillas: usar el componente original sin tabs.
                    // El backend espera los valores legacy que vienen en `props.type`.
                    Backoffice.renderComponent(el[0], ProductMovements, {
                        ...props,
                        created_by: {
                            user: props.user,
                            player: props.player,
                        },
                        concept_details: {
                            booking_date:
                                props.court && props.player
                                    ? moment(props.datetime).toISOString(true)
                                    : '-',
                            court: props.court,
                            booking_id: props.booking_id,
                        },
                        onCloseModal: scope.vm.$close,
                        bookingMovementInfo: props,
                        getUserCode: scope.vm.getUserCode,
                        registerBookingInfoMovement:
                            scope.vm.registerBookingInfoMovement,
                    });
                }

                // Al destruirse, desmontar el root de React (evita fugas en body).
                scope.$on('$destroy', () => {
                    Backoffice.unmountComponent?.(el[0]);
                });
            },
        }),
    ]);

export default moduleName;
